import React from "react";
import "./MessageBubble.css";

const MessageBubble = ({ message, isMine, otherUserInfo, showAvatar }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString("vi-VN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  // Debug log để kiểm tra
  console.log("MessageBubble render:", {
    content: message.Content,
    isMine: isMine,
    UserIDSend: message.UserIDSend,
  });

  return (
    <div
      className={`message-row ${isMine ? "message-mine" : "message-other"}`}
      style={{
        // Force alignment để test
        justifyContent: isMine ? "flex-end" : "flex-start",
      }}
    >
      {/* Avatar cho tin nhắn của người khác CHỈ hiển thị khi KHÔNG phải tin của tôi */}
      {!isMine && (
        <div className="message-avatar">
          {otherUserInfo?.Avatar ? (
            <img
              src={otherUserInfo.Avatar}
              alt={otherUserInfo.Username}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
          ) : null}
          <div
            className="avatar-small-placeholder"
            style={{ display: otherUserInfo?.Avatar ? "none" : "flex" }}
          >
            {otherUserInfo?.Username?.charAt(0).toUpperCase() || "U"}
          </div>
        </div>
      )}

      {/* Nội dung tin nhắn */}
      <div className="message-content-wrapper">
        {/* Hiển thị tên người gửi cho tin nhắn đầu tiên của chuỗi */}
        {!isMine && showAvatar && (
          <div className="message-sender-name">{otherUserInfo?.Username}</div>
        )}

        {/* Bubble chứa nội dung và timestamp */}
        <div className="message-bubble">
          <div className="message-text">{message.Content}</div>
          <div className="message-timestamp">
            {formatTime(message.SendAt || new Date())}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
